import { isEmpty, isNull } from 'lodash-es'

const DECIMAL_POINT = 2

export const formatCurrencyNonRegional = (value: string) => {
  const parts = value.indexOf('.') > 0 ? value.split('.') : [value]
  const decimal = parts.length > 1 && parts[1].length > 0 ? parts[1] : ''
  const chars = parts[0].replaceAll(',', '').split('').reverse()
  const withCommas = []
  for (let i = 1; i <= chars.length; i++) {
    withCommas.push(chars[i - 1])
    if (i % 3 == 0 && i != chars.length) {
      withCommas.push(',')
    }
  }
  const val = value.indexOf('.') > 0 ? withCommas.reverse().join('') + '.' + decimal : withCommas.reverse().join('')
  return val
}

export const formatCurrency = (value?: number | string | null, currency?: string, locale?: string): string => {
  if (typeof value === 'undefined' || isNull(value)) return '-'

  const num = typeof value === 'string' ? Number(value) : value

  if (Number.isNaN(num)) return value.toString()

  if (!currency) {
    const formatter = new Intl.NumberFormat(locale ?? 'en-US', {
      minimumFractionDigits: DECIMAL_POINT,
      maximumFractionDigits: DECIMAL_POINT,
    })

    return formatter.format(num)
  }

  const formatter = new Intl.NumberFormat(locale ?? 'en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: DECIMAL_POINT,
    maximumFractionDigits: DECIMAL_POINT,
  })

  return formatter.format(num)
}

export const formatNumber = (value?: number | string | null, locale?: string): string => {
  if (value === null || typeof value === 'undefined' || value === '') return ''

  const num = typeof value === 'string' ? Number(value) : value

  if (Number.isNaN(num)) return String(value)

  return new Intl.NumberFormat(locale ?? 'en-US').format(num)
}

export const formatCurrencyToNumber = (currency: string) => {
  const numberString = currency.replace(/,/g, '')

  const number = parseFloat(numberString).toFixed(2)

  return number
}

export const addTrailingZerosToCurrency = (targetValue: string, format?: string) => {
  if (format !== 'currency') return ''

  return targetValue.endsWith('.00') ? '.00' : targetValue.endsWith('.0') ? '.0' : ''
}

export const cleanupCurrency = (value = '') => {
  if (isEmpty(value)) {
    return ''
  }
  return value.replace(new RegExp(',', 'g'), '')
}
